import { debounce } from 'lodash'; // Đảm bảo đã cài đặt lodash
import Image from 'next/image';
import { FC, useEffect, useRef, useState } from 'react';

import React from 'react';
import styles from './business-hub-how-it-works.module.scss';

export interface BusinessHubHowItWorksStep {
    description: string;
    descriptionMaxWidth?: string;
    icon: string;
    illustration: string;
}

export interface BusinessHubHowItWorksProps {
    title: string;
    steps: BusinessHubHowItWorksStep[];
}

const BusinessHubHowItWorks: FC<BusinessHubHowItWorksProps> = (props) => {
    const { title, steps = [] } = props;
    const [activeStepIndex, setActiveStepIndex] = useState<number | null>(null);
    const sectionRefs = useRef<(HTMLDivElement | null)[]>([]);

    useEffect(() => {
        const handleScroll = debounce(() => {
            const currentScrollY = window.scrollY;
            let closestIndex = null;
            let smallestDistance = Infinity;

            sectionRefs.current.forEach((section, index) => {
                if (section) {
                    const sectionTop = section.getBoundingClientRect().top + currentScrollY - 30;
                    const distance = Math.abs(currentScrollY - sectionTop);
                    if (distance < smallestDistance) {
                        smallestDistance = distance;
                        closestIndex = index;
                    }
                }
            });

            if (closestIndex !== null) {
                setActiveStepIndex(closestIndex);
            }
        }, 10);

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [steps]);

    if (!steps.length) return null;

    return (
        <div className={styles.container}>
            <div className={styles.background} />
            <div className={styles.box}>
                <div className={styles.parallaxContainer}>
                    <div className={styles.title}>{title}</div>
                    <div className={styles.scrollContent}>
                        {steps.map((step, index) => (
                            <section
                                data-index={index + 1}
                                ref={(el) => (sectionRefs.current[index] = el as HTMLDivElement)}
                                key={index}
                                className={`${styles.section} ${index === activeStepIndex ? styles.activeSection : ''}`}
                            >
                                <div className={styles.sectionContent} data-index={index + 1}>
                                    <div className={styles.progress}>
                                        <div className={styles.progressItem}></div>
                                    </div>
                                    <div className={styles.progressBox}>
                                        <span>{index + 1}</span>
                                    </div>
                                    <div className={styles.sectionContentIcon}>
                                        <div className={styles.sectionContentIconBox}>
                                            <Image
                                                src={step.icon}
                                                alt=""
                                                style={{ objectFit: 'contain', objectPosition: 'center' }}
                                                fill
                                                loader={({ src, width, quality }) => {
                                                    return `${src}?width=${width}&quality=${quality ?? 75}`;
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div
                                        className={styles.sectionContentDescription}
                                        style={{ '--des-max-width': step.descriptionMaxWidth ? `${step.descriptionMaxWidth}px` : null } as React.CSSProperties}
                                        dangerouslySetInnerHTML={{ __html: step.description }}
                                    />
                                </div>
                            </section>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BusinessHubHowItWorks;
